<template>

    <div class="my-actions-container">

        <header-band v-if="!edit"
                     :title="$t('my_actions_title_my_action')"
                     :back="$mq !== 'lg'"
                     :border="false"
                     @eventBack="back"></header-band>

        <div v-else class="fake-header full">

            <img class="fake-header-img" src="/img/icons/cancel-blue.svg" @click="editOff">

            <p class="cf-headline">{{ nbSelected + ' sélectionnées' }}</p>

        </div>

        <div class="nav-actions-container">

            <div class="nav-actions-size">

                <div class="nav-actions-item" :class="{ 'item-selected': step === 1 }" @click="goStep(1)">

                    <img :src="navImgActive(1, 'auto-delete')" class="nav-actions-img">

                    <p class="nav-actions-text" :class="{ 'text-selected': step === 1 }">{{ $t('my_actions_autodelete') }}</p>

                </div>

                <div class="nav-actions-item" :class="{ 'item-selected': step === 2 }" @click="goStep(2)">

                    <img :src="navImgActive(2, 'keep')" class="nav-actions-img">

                    <p class="nav-actions-text" :class="{ 'text-selected': step === 2 }">{{ $t('my_actions_keep') }}</p>

                </div>

            </div>
        </div>

        <div class="card-container">

            <div v-for="item in cardArray" class="card" :class="{ 'card-selected': item.selected, pointer: edit }" @click="toggleCard(item)">

                <transition name="checkboxslide">

                    <div class="card-left" v-show="edit">

                        <checkbox :checked="item.selected" class="checkox-action"></checkbox>

                    </div>

                </transition>

                <div class="card-middle">

                    <p class="myactions__item__title">{{ item.name | capitalizeFirstLetter}}</p>

                    <p class="myactions__item__text">{{ item.sender }}</p>

                </div>

                <div class="card-right">

                    <p class="myactions__item__date">{{ $t('my_actions_since') }}</p>

                    <p class="myactions__item__date">{{ dateFormat(item.date) }}</p>

                </div>

            </div>

        </div>

        <div v-if="loading" class="loader-container">

            <lottie-loader></lottie-loader>

        </div>

        <div v-else class="empty-error-container">

            <template v-if="isSubscriptionsEmpty">

                <img class="empty-error-logo" src="/img/my-actions/empty-auto-delete.svg">

                <p class="cf-headline mt-16 ms-16">{{ $t('my_actions_autodelete_empty_title') }}</p>

                <p class="cf-caption-1 mt-4 ms-16 mh-30 label-description">{{ $t('my_actions_autodelete_empty_description') }}</p>

                <p class="cf-caption-1 text-link-action pointer mt-8 ms-16 label-link" @click="goCleaningList">{{ $t('global_cta_clean') }}</p>

            </template>

            <template v-if="isKeepEmpty">

                <img class="empty-error-logo" src="/img/my-actions/empty-archived.svg">

                <p class="cf-headline mt-16 ms-16">{{ $t('my_actions_keep_empty_title') }}</p>

                <p class="cf-caption-1 mt-4 ms-16 mh-30 label-description">{{ $t('my_actions_keep_empty_description') }}</p>

                <p class="cf-caption-1 text-link-action pointer mt-8 ms-16 label-link" @click="goCleaningList">{{ $t('global_cta_clean') }}</p>

            </template>

            <template v-if="error">

                <img class="empty-error-logo" src="/img/my-actions/actions-error.svg">

                <p class="cf-headline mt-16 ms-16">{{ $t('cleaning_list_oups') }}</p>

                <p class="cf-caption-1 mt-4 ms-16 mh-30 label-description">{{ $t('cleaning_list_text_error') }}</p>

                <p class="cf-caption-1 text-link-action pointer mt-8 ms-16 label-link" @click="refreshData">{{ $t('cleaning_list_cta_error_refresh') }}</p>

            </template>

        </div>

        <button v-if="!isCardArrayEmpty && !edit" class="btn btn-blue btn-action noselect" @click="editOn">

            <img class="action-icon" src="/img/icons/edit-empty.svg">

        </button>

        <button v-if="edit && nbSelected > 0" class="btn btn-action-green btn-action noselect" @click="openMyActionsModal">

            <img class="action-icon" src="/img/icons/action-back-green-white.svg">

        </button>

        <modal-my-actions ref="myactions" @close="modalMyActionsClosing"></modal-my-actions>

        <tab-bar></tab-bar>

    </div>

</template>

<script>

import moment from 'moment'

import Api from '@/api'

import I18n from '@/modules/i18n'
import Tag from '@/modules/tag'
import UserFlow from '@/modules/userFlow'

import Checkbox from '@/components/inputs/Checkbox'
import HeaderBand from '@/components/headers/HeaderBand'
import LottieLoader from '@/components/lottie/LottieLoader'
import ModalMyActions from '@/components/modal/ModalMyActions'

import TabBar from '@/components/TabBar'

export default {

    name: 'my-actions',

    components: { Checkbox, HeaderBand, LottieLoader, ModalMyActions, TabBar },

    computed: {

        nbSelected: function () {

            return this.cardArray.filter(item => item.selected).length

        },

        isSubscriptionsEmpty: function () {

            return this.step === 1 && !this.error && this.cardArray.length === 0 && !this.loading

        },

        isKeepEmpty: function () {

            return this.step === 2 && !this.error && this.cardArray.length === 0 && !this.loading

        },

        isCardArrayEmpty: function () {

            return this.cardArray.length === 0

        },

        selectedArray: function () {

            return this.cardArray.filter(card => card.selected)

        }

    },

    watch: {

        step: function (step) {

            this.editOff()

            if (step === 1) {

                const subscriptions = this.subscriptions
                subscriptions.map(item => item.selected = false)
                this.cardArray = subscriptions

            } else {

                const keep = this.keep
                keep.map(item => item.selected = false)
                this.cardArray = keep

            }

        },

        error: function (bool) {

            if (bool) {

                this.clearArray()

            }

        }
    },

    data () {

        return {
            subscriptions: [],
            keep: [],
            cardArray: [],
            step: 1,
            error: false,
            loading: false,
            edit: false
        }

    },

    created () {

        UserFlow.setPage(this, 'my-actions')

    },

    mounted () {

        moment.locale(I18n.get(this))

        this.requestData()

    },

    methods: {

        requestData () {

            this.loading = true

            Api.newsletters.blocked()
                .then(dataBlocked => {

                    return Api.newsletters.kept()
                        .then(dataKept => {

                            this.loading = false

                            const subscriptions = dataBlocked.subscriptions
                            subscriptions.map(item => item.selected = false)
                            this.subscriptions = subscriptions

                            const keep = dataKept.subscriptions
                            keep.map(item => item.selected = false)
                            this.keep = keep

                            this.cardArray = this.step === 1 ? subscriptions : keep
                        })
                })
                .catch(() => {

                    this.loading = false
                    this.error = true

                })

        },

        refreshData () {

            this.clearArray()

            this.requestData()

        },

        editOn () {

            this.edit = true

        },

        dateFormat (str) {

            return moment(str).format('L')

        },

        goCleaningList () {

            this.$router.push({ path: '/newsletters' })

        },

        toggleCard (item) {

            if (this.edit) {

                item.selected = !item.selected

            }

        },

        openMyActionsModal () {

            Tag.clickAmplitude(this, 'edit')

            this.$refs.myactions.open(this.selectedArray, this.step === 1 ? 'unblock' : 'release')

        },

        navImgActive: function (step, img) {

            return `/img/icons/${img}-${step === this.step ? 'blue' : 'grey'}.svg`
        },

        modalMyActionsClosing () {

            this.refreshData()

        },

        goStep (step) {

            this.step = step

        },

        back () {

            this.$router.push({ path: '/newsletters' })

        },

        editOff () {

            const array = this.cardArray

            array.map(item => item.selected = false)

            this.cardArray = array

            this.edit = false

        },

        clearArray () {

            this.cardArray = []
            this.subscriptions = []
            this.keep = []

        }

    }
}

</script>

<style scoped lang="scss">

    .my-actions-container {
        display: flex;
        flex-direction: column;
        flex-grow: 1;
        align-items: center;
        background-color: $white;
        @media screen and (min-width: $above-tablet-length) {
            background-color: $timberwolf;
        }
    }

    .fake-header {
        height: 49px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-start;
        padding: 0 16px;
        background-color: white;
        @media screen and (min-width: $above-tablet-length) {
            height: 64px;
        }
    }

    .fake-header-img {
        height: 24px;
        object-fit: contain;
        margin-right: 16px;
        cursor: pointer;
    }

    .nav-actions-container {
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-around;
        align-items: center;
        height: 56px;
        background-color: $white;
        margin-top: -1px;
        border-bottom: 1px solid $border-grey;
    }

    .nav-actions-size {
        width: 100%;
        max-width: 360px;
        display: flex;
        flex-direction: row;
        height: 100%;
    }

    .nav-actions-item {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        flex-grow: 1;
        flex: 1;
        height: 100%;
        cursor: pointer;
    }

    .nav-actions-img {
        width: 24px;
        height: 24px;
    }

    .nav-actions-text {
        opacity: 0.5;
        font-size: 12px;
        font-weight: 500;
        line-height: 1.33;
        color: $grey;
    }

    .card-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 100%;
        @media screen and (min-width: $above-tablet-length) {
            margin-top: 89px;
        }
    }

    .card {
        width: 100%;
        height: 72px;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        padding: 20px 16px;
        border-bottom: 1px solid $border-grey;
        background-color: $white;
        @media screen and (min-width: $above-tablet-length) {
            max-width: 501px;
            margin-top: 16px;
            border-radius: 8px;
            box-shadow: 0 15px 50px 0 rgba(0, 0, 0, 0.05);
        }
    }

    .checkox-action {
        width: 16px;
        height: 16px;
    }

    .max-text {
        max-width: 196px;
        @media screen and (min-width: $above-tablet-length) {
            max-width: 400px;
        }
    }

    .card-selected {
        background-color: $selected;
    }

    .card-left {
        min-width: 32px;
        display: flex;
        align-items: start;
    }

    .card-middle {
        display: flex;
        flex-direction: column;
        align-items: start;
        justify-content: center;
        width: 100%;
    }

    .card-right {
        min-width: 59px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-end;
    }

    .empty-error-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        flex-grow: 1;
        background-color: white;
        margin-bottom: 55px;
        @media screen and (min-width: $above-tablet-length) {
            margin-bottom: 0;
            background-color: $timberwolf;
        }
    }

    .loader-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        flex-grow: 1;
    }

    .empty-error-logo {
        width: 96px;
        object-fit: contain;
    }

    .text-link-action {
        font-size: 12px;
        font-weight: bold;
        line-height: 1.33;
        color: $aquamarine;
    }

    .btn-action-green {
        background-color: #00d191;
    }

    .mh-30 {
        min-height: 30px;
    }

    .btn-action {
        display: flex;
        align-items: center;
        justify-content: center;
        position: fixed;
        bottom: 72px;
        width: 56px;
        height: 56px;
        @media screen and (min-width: $above-tablet-length) {
            bottom: 32px;
            right: 32px;
        }
    }

    .action-icon {
        width: 24px;
        object-fit: contain;
    }

    .my-actions-icon {
        width: 32px;
        object-fit: contain;
    }

    .item-selected {
        border-bottom: 1px solid $blue;
    }

    .text-selected {
        color: $blue;
        opacity: 1;
    }

    .myactions {
            &__item {
                &__title {
                    font-size: 17px;
                    font-weight: bold;
                    color: $midnight;
                }

                &__text {
                    font-size: 12px;
                    color: $moon;
                }

                &__date {
                    font-size: 12px;
                    color: $moon;
                }
            }
    }

    .label-description {
        font-size: 15px;
        line-height: 1.33;
        text-align: center;
        color: $moon;
        text-decoration: none;
    }

    .label-link {
        font-size: 17px;
        font-weight: bold;
        line-height: 1.41;
        text-align: center;
        color: $aquamarine;
        text-decoration: none;
    }

    /*animation*/


    .checkboxslide-enter-active {
        animation: animCheckboxSlideEnter .1s ease-in-out;
    }

    .checkboxslide-leave-active {
        animation: animCheckboxSlideLeave .1s ease-in-out;
    }

    /*.checkboxslide-enter {*/
    /*opacity: 0;*/
    /*}*/

    /*.checkboxslide-leave-to {*/
    /*opacity: 1;*/
    /*}*/

    @keyframes animCheckboxSlideEnter {

        0% {
            opacity: 0;
            width: 0px;
            min-width: 0px;
        }

        100% {
            opacity: 1;
            width: 32px;
            min-width: 32px;
        }
    }

    @keyframes animCheckboxSlideLeave {

        0% {
            opacity: 1;
            width: 32px;
            min-width: 32px;
        }

        100% {
            opacity: 0;
            width: 0px;
            min-width: 0px;
        }
    }
</style>

